import axios from 'axios';
import { cachetime } from '../config';

export default function() {
  return {
    namespaced: true,
    state: {
      videos: {}
    },
    mutations: {
      SET_VIDEOS(state, { data, locale }) {
        state.videos = {
          ...state.videos,
          [locale]: {
            data,
            __updatedAt: Date.now(),
          }
        }
      },
    },
    actions: {
      FETCH_VIDEOS({ state, commit }, { locale }) {
        if (state.videos[locale] && Date.now() - state.videos[locale].__updatedAt < cachetime) return;

        return axios.get(encodeURI(`/api/videogallery`))
          .then((res) => {
            const data = res.data || [];
            commit('SET_VIDEOS', { data, locale});
          }).catch(err => console.log(err));      
      },
    },
    getters: { 
      getVideos: (state) => (locale) => {
        return state.videos[locale] ? state.videos[locale].data || [] : [];
      }
    }
  }
}